import { Trans } from '@lingui/macro'
import { Button } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import { FormErrorsList } from '../../common/FormErrorsList'

/**
 * Form element which renders an additional save button that is used in saving the form.
 * @category Form
 * @subcategory Form elements
 * @component
 * @returns {JSX.Element}
 * @param  {Object} typeProps - Element specific properties that can be configured in form editor.
 * @param  {boolean}  [typeProps.showAllErrors=false] Above the button, render the current list of error for the the whole form.
 * @param  {boolean}  [typeProps.showSectionErrors=false] Above the button, render the current list of error for the the section button is in.
 */
export const FormSaveButton = ({
  saving,
  connectedMap,
  objectsFieldsMap,
  describeMap,
  saveButtonClicked,
  saveDisabled,
  errors,
  disabled,
  sectionIndex,
  navigateToError,
  typeProps,
  title
}) => {
  const { showAllErrors, showSectionErrors, errorListTitle } = typeProps
  const { values } = useFormikContext()
  let errorsToPass = errors || []
  if (showSectionErrors) {
    errorsToPass = errorsToPass.filter(obj => sectionIndex === obj.sectionIndex)
  }

  return (
    <Field>
      {({ form }) => (
        <>
          {!disabled && (showAllErrors || showSectionErrors) && (
            <FormErrorsList
              title={errorListTitle || <Trans>FORM_SAVE_BUTTON_ERRORS_LIST_HEADER</Trans>}
              helperText={
                showSectionErrors
                  ? (
                    <Trans>
                      You have not completed all required fields on this page
                    </Trans>
                    )
                  : (
                    <Trans>You have not completed all required fields</Trans>
                    )
              }
              navigateToError={navigateToError}
              errors={errorsToPass}
              objectsFieldsMap={objectsFieldsMap}
              describeMap={describeMap}
              connectedMap={connectedMap}
            />
          )}
          <Button
            onClick={e => {
              saveButtonClicked({ values })
            }}
            disabled={saving || saveDisabled || disabled || !form.dirty}
            color='primary'
            variant='contained'
            fullWidth
          >
            {title || <Trans>Save</Trans>}
          </Button>
        </>
      )}
    </Field>
  )
}
